import api from '@/factories/api';

export default {
  namespaced: true,

  state: {
    folders: [],
    foldersLoaded: false,
    folderLoading: false,
  },

  mutations: {
    setFolders: (state, folders) => {
      state.folders = folders;
    },
    setFoldersLoaded: (state, loaded) => {
      state.foldersLoaded = loaded;
    },
    setFolderLoading: (state, loading) => {
      state.folderLoading = loading;
    },
  },

  getters: {
    getFolder(state) {
      return (folderId) => state.folders.find((i) => i.id === folderId);
    },
  },

  actions: {
    async loadFolders({ commit, state }) {
      if (state.foldersLoaded) return;

      try {
        const folders = await api().get('cg/files_folders?schema=full');
        commit('setFolders', folders);
      } finally {
        commit('setFoldersLoaded', true);
      }
    },

    async loadSingleFolder({ commit, getters }, folderId) {
      if (getters.getFolder(folderId)) return;

      try {
        const folder = await api().get(
          `cg/files_folders/${folderId}?schema=full`
        );
        const folders = [folder, ...state.folders];
        commit('setFolders', folders);
      } finally {
        commit('setFolderLoading', false);
      }
    },
  },
};
